(function (win, $) {
    'use strict';

    // Trigger live chat
    const doc = win.document,
        $win = $(win),
        $doc = $(doc),
        $body = $('body'),
        $grid = $('main .grid').first(),
        $footer = $('#main-footer'),
        statusUrl = $('#_lcstatuslink').prop('href') || $body.data('livechatstatus'),
        cbButtonId = 'chatBeaconBtn',
        cookieName = 'dkchatting',
        cookieVal = '1',
        clickEventName = 'click.livechat',
        chatScriptUrl = 'https://livechat.niddk.nih.gov/chatbeacon/NIDDK/1/scripts/chatbeacon.js?accountId=1&siteId=1&queueId=1&m=0&i=1&b=1&c=1&theme=frame';
    let $cbButton, cbButtonOuter, isOnline, showBadge, noBadge, loadChatScriptCalled, cookieSet,
        $floating = $('.livechat-floating').first(),
        $badge = $('.livechat-badge', $floating),
        $buttons = $('[data-trigger-chat]');

    // Set a session cookie to indicate that the user has activated chat so that it can automatically
    // load on subsequent pages
    function setUsingChat(clearCookie) {
        if (!!clearCookie !== !!cookieSet) return; // !! to coerce values to boolean
        let val = clearCookie ? '' : cookieVal, ck = cookieName + '=' + val + ';path=/';
        if (!val) {
            let d = new Date();
            d.setTime(d.getTime() + (-10 * 24 * 60 * 60 * 1000));
            ck += ';expires=' + d.toUTCString();
        }
        document.cookie = ck;
        cookieSet = !!val;
    }

    // Determine if the "actively chatting" cookie is set
    function isUsingChat() {
        return document.cookie.split(/; ?/)
            .map(s => s.split('='))
            .reduce((o, v) => (o[v[0]] = v[1], o), {})[cookieName] === cookieVal;
    }

    // Handle positioning of floating Live Chat badge
    function badgePosition() {
        const left = $grid[0].getBoundingClientRect().left,
            padding = parseInt($grid.css('paddingLeft')),
            badgeWidth = $badge.width();

        if ($doc.scrollTop() + win.innerHeight >= $footer.offset().top) {
            (win.innerWidth >= 1200) ? $badge.css({'position': 'absolute', 'right': left - badgeWidth}) : $badge.css({'position': 'absolute', 'right': padding * (2/3) });
        } else {
            (win.innerWidth >= 1200) ? $badge.css({'position': 'fixed', 'right': left - badgeWidth }) : $badge.css({'position': 'fixed', 'right': padding * (2/3) });
        }
    }

    // Update the online state of the buttons
    function updateButtonOnlineState() {
        if (isOnline) {
            $body.addClass('livechat-online');
            $buttons.attr({'aria-label': 'Open live chat window', 'title': 'Start a chat with us'});
        } else {
            $buttons.attr({'aria-label': 'Open a window to write us', 'title': 'Write us'});
        }
    }

    // Enable triggering the chat provider's event handler once it is loaded
    function onChatProviderLoaded(fromClick) {
        if (!cbButtonOuter) return;

        updateButtonOnlineState();

        function findAndTriggerButton(e) {
            // Keep looking for the button until it is found
            $cbButton = ($cbButton && $cbButton.length) ? $cbButton : $('>button', cbButtonOuter).first();
            if ($cbButton.length) {
                if (e) e.preventDefault();
                setUsingChat();
                $cbButton.trigger('click');
                if (e) return false;
            }
        }

        // Re-bind the chat trigger buttons to open the chat window
        $body.addClass('livechat-loaded')
            .off(clickEventName).on(clickEventName, '[data-trigger-chat]', findAndTriggerButton);

        // If the user clicked a chat trigger button, launch the chat window immediately
        if (fromClick) findAndTriggerButton();
    }

    // Update the live chat status classes and adjust the markup and events
    function updateChatStatus() {
        if (showBadge) $body.addClass('livechat-showbadge');

        updateButtonOnlineState();

        if (showBadge) {
            badgePosition();
            $win.off('dk:widthChanged.chatbadge').on('dk:widthChanged.chatbadge', function(_, {layoutChanged, isMobile}) {
                if (layoutChanged) {
                    if (isMobile) {
                        $('.livechat-floating .livechat-badge').css({'display': 'block', 'position': 'fixed', 'left': '', 'right': ''});
                        $win.off('scroll.chatbadge');
                    } else {
                        badgePosition();
                        $win.on('scroll.chatbadge', function () { badgePosition(); });
                    }
                } else if (!isMobile) {
                    badgePosition();
                }
            });
        } else {
            $('.livechat-floating').remove();
            noBadge = true;
        }
    }

    function loadChatScript(fromClick) {
        // Ensure this method is only called once per page
        if (loadChatScriptCalled) return;
        loadChatScriptCalled = true;

        // Determine if the chat script is already loaded, and if not, watch for the button to be added to the DOM
        if ((cbButtonOuter = doc.getElementById(cbButtonId))) {
            onChatProviderLoaded(fromClick);
        } else {
            const MO = win.MutationObserver || win.WebKitMutationObserver;
            if (MO) {
                let observer = new MO(mutations => {
                    mutations.forEach(mutation => {
                        let nodes = Array.prototype.slice.call(mutation.addedNodes);
                        const button = nodes.filter(node => node.id === cbButtonId)[0];
                        if (button) {
                            if (observer) observer.disconnect();
                            observer = null;
                            cbButtonOuter = button;
                            onChatProviderLoaded(fromClick);
                        }
                    });
                });
                observer.observe(doc.body, { childList: true });
            }
        }

        // Inject the live chat script into the DOM
        let s = document.createElement('script');
        s.defer = true;
        s.src = chatScriptUrl;
        document.body.appendChild(s);
    }

    if (statusUrl) {
        // Only set up live chat if the chat status URL is available
        fetch(statusUrl).then(r => r.json())
            .then(data => {
                isOnline = (data.online || data['Online']) ? true : false;
                showBadge = (data.badge || data.badgeEnabled || data['Badge'] || data['BadgeEnabled']) ? true : false;
                updateChatStatus();
            })
            .catch(() => {
                updateChatStatus();
            });
    } else {
        $('.livechat-floating').remove();
        noBadge = true;
    }

    // On document loaded
    $(function () {
        const $footerChatIcon = $('.livechat-source .livechat-badge').first();
        if (!noBadge && !$floating.length && $footerChatIcon.length) {
            // The floating badge is not on the page; clone it from the .livechat-source
            $floating = $('<div class="livechat-floating"></div>');
            $badge = $footerChatIcon.clone().removeAttr('style');
            // Fix SVG gradient IDs to avoid duplication on the page
            $badge.find('linearGradient[id]').each(function () {
                const $grad = $(this), origId = $grad.attr('id'), newId = win.dk.generateId('svg');
                $grad.attr('id', newId);
                $badge.find('[fill]').each(function () {
                    const $elt = $(this), fill = $elt.attr('fill') || '';
                    if (fill.startsWith('url(#') && fill.indexOf(origId) >= 0) {
                        $elt.attr('fill', fill.replace(origId, newId));
                    }
                });
            });
            $('main').append($floating.append($badge));
            $buttons = $buttons.add($badge);
            badgePosition();
        }
        if (isUsingChat()) {
             // Load live chat scripts when chat was previously launched this session.
             // This allows continued sessions if the user navigates while chatting.
            loadChatScript();
        } else {
            $body.off(clickEventName).on(clickEventName, '[data-trigger-chat]', function (e) {
                e.preventDefault();
                loadChatScript(true); // 'true' argument indicates a click, so that chat is immediately triggered
                return false;
            });
        }
    });
})(window, window.jQuery);
